import React from 'react';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import StateSelect from './StateSelect';
import { emptyAddress } from './address';

// Street / Unit / City / State / ZIP block used by the opportunity dialogs
// (ticket 75). `value` is an Address object; `onChange` receives the whole
// object. Lays out as a 2-column grid so it drops into the dialogs' existing
// grid-cols-2 forms.
export default function AddressFields({ value, onChange, testIdPrefix = 'address', label = 'Property Address' }) {
  const a = { ...emptyAddress(), ...(value || {}) };
  const upd = (k) => (v) => onChange({ ...a, [k]: v });
  return (
    <div className="col-span-2 grid grid-cols-2 gap-3" data-testid={testIdPrefix}>
      <div className="col-span-2">
        {label && <Label>{label}</Label>}
        <Input value={a.street} placeholder="Street" onChange={(e) => upd('street')(e.target.value)} data-testid={`${testIdPrefix}-street`} />
      </div>
      <div>
        <Label className="text-xs text-slate-500">Unit</Label>
        <Input value={a.unit} placeholder="Apt / Suite" onChange={(e) => upd('unit')(e.target.value)} data-testid={`${testIdPrefix}-unit`} />
      </div>
      <div>
        <Label className="text-xs text-slate-500">City</Label>
        <Input value={a.city} onChange={(e) => upd('city')(e.target.value)} data-testid={`${testIdPrefix}-city`} />
      </div>
      <StateSelect value={a.state || undefined} onChange={upd('state')} testId={`${testIdPrefix}-state`} />
      <div>
        <Label className="text-xs text-slate-500">ZIP</Label>
        <Input value={a.zip} inputMode="numeric" maxLength={10} onChange={(e) => upd('zip')(e.target.value)} data-testid={`${testIdPrefix}-zip`} />
      </div>
    </div>
  );
}
